module.exports = __webpack_public_path__ + "img/confirm-btn_no.2ca8c0a1.png";